
import React, { useEffect, useState } from "react";
import axios from "axios";
import "../Styles/ManageGallery.css";

function PhotoGallery() {
  const [images, setImages] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  const photosPerPage = 12;

  // ========================================
  // LOAD PHOTOS
  // ========================================

  useEffect(() => {
    axios
      .get("/api/gallery/images")
      .then((res) => {
        setImages(res.data);
      })
      .catch((err) => {
        console.error("Image fetch error:", err);
      });
  }, []);

  // ========================================
  // IMAGE URL
  // ========================================

  const getImageUrl = (fileUrl) => {
    if (!fileUrl) return "";

    if (fileUrl.startsWith("http://localhost:8080")) {
      return fileUrl.replace(
        "http://localhost:8080",
        ""
      );
    }

    if (fileUrl.startsWith("http://") ||
        fileUrl.startsWith("https://")) {
      return fileUrl;
    }

    return fileUrl.startsWith("/")
      ? fileUrl
      : `/${fileUrl}`;
  };

  // ========================================
  // PAGE CALCULATION
  // ========================================

  const totalPages = Math.ceil(
    images.length / photosPerPage
  );

  const startIndex = currentPage * photosPerPage;

  const currentImages = images.slice(
    startIndex,
    startIndex + photosPerPage
  );

  // ========================================
  // NEXT PAGE
  // ========================================

  const handleNext = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage((prev) => prev + 1);

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  // ========================================
  // PREVIOUS PAGE
  // ========================================

  const handlePrevious = () => {
    if (currentPage > 0) {
      setCurrentPage((prev) => prev - 1);

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  // ========================================
  // PAGE
  // ========================================

  return (
    <div className="manage-gallery-container">

      {/* HEADER */}

      <div className="manage-gallery-header">
        <h2>📷 Photo Gallery</h2>
      </div>

      {/* PHOTOS */}

      <section className="gallery-section">

        {images.length === 0 ? (
          <p className="empty-message">
            No photos available.
          </p>
        ) : (
          <>
            <div className="manage-gallery-grid">

              {currentImages.map((image) => (
                <div
                  className="manage-gallery-card"
                  key={image.id}
                >

                  {/* PHOTO */}

                  <div className="media-container">
                    <img
                      src={getImageUrl(image.fileUrl)}
                      alt={image.title || "Temple Gallery"}
                      className="gallery-photo"
                    />
                  </div>

                  {/* PHOTO DETAILS */}

                  <div className="media-details">
                    <h4>{image.title}</h4>

                    <p>
                      {image.description ||
                        "No description"}
                    </p>
                  </div>

                </div>
              ))}

            </div>

            {/* PAGINATION */}

            {totalPages > 1 && (
              <div className="photo-gallery-pagination">

                <button
                  className="photo-gallery-page-btn"
                  onClick={handlePrevious}
                  disabled={currentPage === 0}
                >
                  &#10094;
                </button>

                <span className="photo-gallery-page-number">
                  Page {currentPage + 1} of {totalPages}
                </span>

                <button
                  className="photo-gallery-page-btn"
                  onClick={handleNext}
                  disabled={currentPage === totalPages - 1}
                >
                  &#10095;
                </button>

              </div>
            )}

          </>
        )}

      </section>

    </div>
  );
}

export default PhotoGallery;
